import React from 'react'

const Contactimage2 = () => {
  return (
    <>
        <svg className='md:w-80 w-44'
          width="277"
          height="238"
          viewBox="0 0 277 238"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M127.156 90.628L156.596 143.533L110.35 134.62L127.156 90.628Z"
            fill="url(#paint0_linear_714_1945)"
          />
          <path
            d="M127.159 90.6288L156.599 143.534L242.52 61.0764L127.159 90.6288Z"
            fill="url(#paint1_linear_714_1945)"
          />
          <path
            d="M55.9806 98.6015L110.373 134.617L127.158 90.6293L55.9806 98.6015Z"
            fill="url(#paint2_linear_714_1945)"
          />
          <path
            d="M112.302 199.816L110.371 134.614L55.9809 98.6056L25.9036 116.071L34.7 176.724L81.6054 216.169L112.302 199.816Z"
            fill="url(#paint3_linear_714_1945)"
            fill-opacity="0.5"
          />
          <path
            d="M87.2564 182.121L139.191 197.904L156.599 143.533L127.159 90.6282L71.7793 76.7621L57.8163 129.216L87.2564 182.121Z"
            fill="url(#paint4_radial_714_1945)"
            fill-opacity="0.5"
          />
          <path
            d="M57.8169 129.215L87.2568 182.119L34.6937 176.722L57.8169 129.215Z"
            fill="url(#paint5_linear_714_1945)"
          />
          <path
            d="M57.8169 129.216L87.257 182.121L242.519 61.0737L57.8169 129.216Z"
            fill="url(#paint6_linear_714_1945)"
            fill-opacity="0.9"
          />
          <path
            d="M81.6084 216.17L87.2568 182.121L34.6934 176.723L81.6084 216.17Z"
            fill="url(#paint7_linear_714_1945)"
            fill-opacity="0.5"
          />
          <path
            d="M25.9033 116.067L57.8159 129.215L34.696 176.728L25.9033 116.067Z"
            fill="url(#paint8_linear_714_1945)"
            fill-opacity="0.5"
          />
          <path
            d="M81.6086 216.173L87.257 182.123L139.192 197.907L81.6086 216.173Z"
            fill="url(#paint9_linear_714_1945)"
          />
          <path
            d="M25.9047 116.067L57.8173 129.215L71.78 76.761L25.9047 116.067Z"
            fill="url(#paint10_linear_714_1945)"
          />
          <path
            d="M25.9047 116.067L57.8173 129.215L71.78 76.761L25.9047 116.067Z"
            fill="url(#paint11_linear_714_1945)"
            fill-opacity="0.6"
          />
          <path
            d="M242.522 61.0738L87.2571 182.123L139.192 197.906L242.522 61.0738Z"
            fill="url(#paint12_linear_714_1945)"
            fill-opacity="0.9"
          />
          <path
            d="M242.521 61.0719L57.8127 129.21L71.7754 76.7562L242.521 61.0719Z"
            fill="url(#paint13_linear_714_1945)"
            fill-opacity="0.9"
          />
          <defs>
            <linearGradient
              id="paint0_linear_714_1945"
              x1="85.0364"
              y1="183.354"
              x2="41.9186"
              y2="121.992"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.227296" stop-color="#47FFDE" stop-opacity="0.8" />
              <stop offset="1" stop-color="#6D61FF" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_714_1945"
              x1="85.0372"
              y1="183.358"
              x2="41.9193"
              y2="121.996"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.227296" stop-color="#47FFDE" stop-opacity="0.8" />
              <stop offset="1" stop-color="#6D61FF" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_714_1945"
              x1="68.7431"
              y1="78.4515"
              x2="90.2304"
              y2="122.012"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.227296" stop-color="#47FFDE" stop-opacity="0.8" />
              <stop offset="1" stop-color="#6D61FF" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_714_1945"
              x1="128.561"
              y1="124.492"
              x2="16.5107"
              y2="186.846"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#6D61FF" />
              <stop offset="1" stop-color="#47FFDE" />
            </linearGradient>
            <radialGradient
              id="paint4_radial_714_1945"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(107.208 136.374) rotate(-119.095) scale(102.642 58.7534)"
            >
              <stop stop-color="#6D61FF" />
              <stop offset="1" stop-color="#47FFDE" />
            </radialGradient>
            <linearGradient
              id="paint5_linear_714_1945"
              x1="85.0367"
              y1="183.355"
              x2="41.9187"
              y2="121.994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.227296" stop-color="#47FFDE" stop-opacity="0.8" />
              <stop offset="1" stop-color="#6D61FF" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_714_1945"
              x1="68.5307"
              y1="180.3"
              x2="157.564"
              y2="226.176"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0.0729167"
                stop-color="#4B86FA"
                stop-opacity="0.8"
              />
              <stop offset="0.791667" stop-color="#FCA6EF" stop-opacity="0.8" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_714_1945"
              x1="86.4619"
              y1="180.692"
              x2="31.3338"
              y2="178.244"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BFFE7" stop-opacity="0.8" />
              <stop offset="1" stop-color="#322994" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_714_1945"
              x1="58.6107"
              y1="130.643"
              x2="22.0286"
              y2="124.31"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#7BFFE7" stop-opacity="0.9" />
              <stop offset="1" stop-color="#322994" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_714_1945"
              x1="136.157"
              y1="199.596"
              x2="69.8654"
              y2="175.278"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.586705" stop-color="#47FFDE" stop-opacity="0.9" />
              <stop offset="1" stop-color="#6D61FF" stop-opacity="0.5" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_714_1945"
              x1="27.9874"
              y1="116.19"
              x2="61.4835"
              y2="135.529"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0A3892" />
              <stop offset="0.536458" stop-color="#29B2ED" stop-opacity="0.8" />
              <stop offset="0.967948" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_714_1945"
              x1="50.4424"
              y1="135.591"
              x2="48.4086"
              y2="100.504"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF439D" />
              <stop offset="1" stop-color="#FF43D6" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_714_1945"
              x1="222.164"
              y1="116.539"
              x2="180.844"
              y2="76.8514"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0.0729167"
                stop-color="#4B86FA"
                stop-opacity="0.8"
              />
              <stop offset="0.791667" stop-color="#FCA6EF" stop-opacity="0.8" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_714_1945"
              x1="-91.8837"
              y1="103.254"
              x2="-14.3392"
              y2="-60.4736"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0.0729167"
                stop-color="#4B86FA"
                stop-opacity="0.8"
              />
              <stop offset="0.791667" stop-color="#FCA6EF" stop-opacity="0.8" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
          </defs>
        </svg>
        <svg className='md:w-80 w-44'
          width="93"
          height="92"
          viewBox="0 0 93 92"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54.681 16.4519L52.8418 30.8826L63.5709 43.1251L76.6525 41.7696L71.0879 25.4274L54.681 16.4519Z"
            fill="url(#paint0_linear_714_1934)"
            fill-opacity="0.7"
          />
          <path
            d="M17.6 70.3841L57.0893 59.7471L74.929 57.2971L17.6 70.3841Z"
            fill="url(#paint1_linear_714_1934)"
            fill-opacity="0.8"
          />
          <path
            d="M17.5991 70.386L36.6753 36.3615L39.3746 16.4989L17.5991 70.386Z"
            fill="url(#paint2_linear_714_1934)"
          />
          <path
            d="M39.3723 16.5038L36.6786 36.373L52.8423 30.8838L54.6828 16.4498L39.3723 16.5038Z"
            fill="url(#paint3_linear_714_1934)"
            fill-opacity="0.6"
          />
          <path
            d="M57.0864 59.7439L36.6796 36.3684L52.8444 30.8787L63.5714 43.1201L57.0864 59.7439Z"
            fill="url(#paint4_linear_714_1934)"
            fill-opacity="0.6"
          />
          <path
            d="M57.0839 59.7505L74.9265 57.2961L76.6526 41.7671L63.5703 43.1232L57.0839 59.7505Z"
            fill="url(#paint5_linear_714_1934)"
            fill-opacity="0.8"
          />
          <path
            d="M17.6 70.384L65.8082 30.9632L74.9289 57.2969L17.6 70.384Z"
            fill="url(#paint6_linear_714_1934)"
          />
          <path
            d="M17.5993 70.3835L65.8049 30.9625L39.3748 16.4962L17.5993 70.3835Z"
            fill="url(#paint7_linear_714_1934)"
          />
          <path
            d="M74.9272 57.2983L65.8079 30.9622L71.0886 25.4239L76.6521 41.7749L74.9272 57.2983Z"
            fill="url(#paint8_linear_714_1934)"
            fill-opacity="0.6"
          />
          <path
            d="M39.3673 16.5041L65.8038 30.9649L71.0895 25.4265L54.6753 16.4506L39.3673 16.5041Z"
            fill="url(#paint9_linear_714_1934)"
            fill-opacity="0.6"
          />
          <defs>
            <linearGradient
              id="paint0_linear_714_1934"
              x1="47.7539"
              y1="26.2042"
              x2="73.1973"
              y2="27.7512"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#6587FF" />
              <stop offset="1" stop-color="#D8E0FF" stop-opacity="0.9" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_714_1934"
              x1="53.4702"
              y1="39.7448"
              x2="72.4615"
              y2="73.3323"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.135417" stop-color="white" />
              <stop
                offset="0.28125"
                stop-color="#89F8FF"
                stop-opacity="0.934673"
              />
              <stop
                offset="0.645833"
                stop-color="#71F6FF"
                stop-opacity="0.921354"
              />
              <stop offset="1" stop-color="#4A72FF" stop-opacity="0.9" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_714_1934"
              x1="17.7459"
              y1="32.1731"
              x2="34.9844"
              y2="61.1509"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.170794" stop-color="#3D3BA9" />
              <stop offset="0.537799" stop-color="#FF7BE2" stop-opacity="0.8" />
              <stop offset="0.791667" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_714_1934"
              x1="46.3917"
              y1="10.5079"
              x2="55.1321"
              y2="30.3568"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.135417" stop-color="white" />
              <stop
                offset="0.28125"
                stop-color="#89F8FF"
                stop-opacity="0.934673"
              />
              <stop
                offset="0.645833"
                stop-color="#71F6FF"
                stop-opacity="0.921354"
              />
              <stop offset="1" stop-color="#4A72FF" stop-opacity="0.9" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_714_1934"
              x1="43.0367"
              y1="30.9383"
              x2="35.6078"
              y2="52.1741"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.135417" stop-color="white" />
              <stop
                offset="0.28125"
                stop-color="#89F8FF"
                stop-opacity="0.934673"
              />
              <stop
                offset="0.645833"
                stop-color="#71F6FF"
                stop-opacity="0.921354"
              />
              <stop offset="1" stop-color="#4A72FF" stop-opacity="0.9" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_714_1934"
              x1="73.9689"
              y1="42.1582"
              x2="81.8272"
              y2="57.2721"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.135417" stop-color="white" />
              <stop
                offset="0.28125"
                stop-color="#89F8FF"
                stop-opacity="0.934673"
              />
              <stop
                offset="0.645833"
                stop-color="#71F6FF"
                stop-opacity="0.921354"
              />
              <stop offset="1" stop-color="#4A72FF" stop-opacity="0.9" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_714_1934"
              x1="35.588"
              y1="91.0659"
              x2="45.3155"
              y2="38.1909"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3DDCFF" />
              <stop offset="0.427083" stop-color="#9D50FF" stop-opacity="0" />
              <stop offset="0.977116" stop-color="#3DDCFF" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_714_1934"
              x1="59.2106"
              y1="10.4982"
              x2="55.4164"
              y2="85.7689"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.170794" stop-color="#3D3BA9" />
              <stop offset="0.537799" stop-color="#FF7BE2" stop-opacity="0.8" />
              <stop offset="0.791667" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_714_1934"
              x1="73.083"
              y1="24.748"
              x2="78.1866"
              y2="56.279"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.135417" stop-color="white" />
              <stop
                offset="0.28125"
                stop-color="#89F8FF"
                stop-opacity="0.934673"
              />
              <stop
                offset="0.645833"
                stop-color="#71F6FF"
                stop-opacity="0.921354"
              />
              <stop offset="1" stop-color="#4A72FF" stop-opacity="0.9" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_714_1934"
              x1="48.514"
              y1="27.2124"
              x2="65.0705"
              y2="13.0704"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3E5ABE" />
              <stop offset="1" stop-color="#3E5ABE" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <svg className='md:w-80 w-44'
          width="119"
          height="119"
          viewBox="0 0 119 119"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M57.7055 61.1353L51.4544 29.7114L81.6566 40.4055L87.9078 71.8295L57.7055 61.1353Z"
            fill="url(#paint0_linear_714_1929)"
          />
          <path
            d="M81.6568 40.4112L51.4546 29.7171L27.4692 87.3062L81.6568 40.4112Z"
            fill="url(#paint1_linear_714_1929)"
            fill-opacity="0.6"
          />
          <path
            d="M81.6561 40.4115L87.9432 71.8258L27.4685 87.3064L81.6561 40.4115Z"
            fill="url(#paint2_linear_714_1929)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_714_1929"
              x1="50.0382"
              y1="49.3542"
              x2="89.3239"
              y2="52.1865"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#6083FF" />
              <stop offset="1" stop-color="#0C1E5E" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_714_1929"
              x1="59.1769"
              y1="25.5663"
              x2="27.3029"
              y2="87.1139"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.170794" stop-color="#3D3BA9" />
              <stop offset="0.537799" stop-color="#FF7BE2" stop-opacity="0.8" />
              <stop offset="0.791667" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_714_1929"
              x1="27.6841"
              y1="87.5555"
              x2="85.3665"
              y2="68.3114"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3DDCFF" />
              <stop offset="0.427083" stop-color="#9D50FF" stop-opacity="0.5" />
              <stop offset="0.977116" stop-color="#3DDCFF" />
            </linearGradient>
          </defs>
        </svg>
        <svg className='md:w-80 w-44'
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.0005 36.4865L31.3431 17.4545L49.5696 24.0421L53.2269 43.0741L35.0005 36.4865Z"
            fill="url(#paint0_linear_714_1924)"
          />
          <path
            d="M49.5731 24.0397L31.3436 17.451L16.606 52.1963L49.5731 24.0397Z"
            fill="url(#paint1_linear_714_1924)"
            fill-opacity="0.6"
          />
          <path
            d="M49.5717 24.0391L53.2515 43.0687L16.6047 52.1958L49.5717 24.0391Z"
            fill="url(#paint2_linear_714_1924)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_714_1924"
              x1="30.4091"
              y1="29.3303"
              x2="54.1609"
              y2="31.1983"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#6083FF" />
              <stop offset="1" stop-color="#0C1E5E" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_714_1924"
              x1="36.0317"
              y1="14.9703"
              x2="16.5064"
              y2="52.0795"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.170794" stop-color="#3D3BA9" />
              <stop offset="0.537799" stop-color="#FF7BE2" stop-opacity="0.8" />
              <stop offset="0.791667" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_714_1924"
              x1="16.7342"
              y1="52.3473"
              x2="51.7065"
              y2="40.9325"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3DDCFF" />
              <stop offset="0.427083" stop-color="#9D50FF" stop-opacity="0.5" />
              <stop offset="0.977116" stop-color="#3DDCFF" />
            </linearGradient>
          </defs>
        </svg>
        {/* <svg className='w-80'
          width="115"
          height="114"
          viewBox="0 0 115 114"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M56.1146 58.2078L50.3184 28.0454L79.204 38.4856L85.0001 68.648L56.1146 58.2078Z"
            fill="url(#paint0_linear_714_1919)"
          />
          <path
            d="M79.2038 38.489L50.3183 28.0489L26.9658 83.1047L79.2038 38.489Z"
            fill="url(#paint1_linear_714_1919)"
          />
          <path
            d="M79.2042 38.4938L85.035 68.6473L26.9663 83.1096L79.2042 38.4938Z"
            fill="url(#paint2_linear_714_1919)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_714_1919"
              x1="48.8382"
              y1="46.8664"
              x2="86.4804"
              y2="49.827"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#6083FF" />
              <stop offset="1" stop-color="#0C1E5E" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_714_1919"
              x1="57.7469"
              y1="24.1181"
              x2="26.8077"
              y2="82.9195"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.170794" stop-color="#3D3BA9" />
              <stop offset="0.537799" stop-color="#FF7BE2" stop-opacity="0.8" />
              <stop offset="0.791667" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_714_1919"
              x1="27.1714"
              y1="83.3497"
              x2="82.5868"
              y2="65.2624"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3DDCFF" />
              <stop offset="0.427083" stop-color="#9D50FF" stop-opacity="0" />
              <stop offset="0.977116" stop-color="#3DDCFF" />
            </linearGradient>
          </defs>
        </svg> */}
        {/* <svg className='w-8'
          width="1473"
          height="1150"
          viewBox="0 0 1473 1150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="563.887"
            y="590.332"
            width="4.91407"
            height="4.91407"
            transform="rotate(-85.5031 563.887 590.332)"
            fill="#00F0FF"
            fill-opacity="0.5"
          />
          <rect
            x="564.088"
            y="392.063"
            width="2.02624"
            height="2.02623"
            transform="rotate(-85.5031 564.088 392.063)"
            fill="#00F0FF"
          />
          <rect
            width="2.66099"
            height="2.66098"
            transform="matrix(-0.078406 0.996921 0.996922 0.0784061 963.67 354.687)"
            fill="#00F0FF"
          />
          <rect
            x="637.104"
            y="338.91"
            width="3.06445"
            height="3.06444"
            transform="rotate(-85.5031 637.104 338.91)"
            fill="#00F0FF"
          />
          <rect
            x="645.899"
            y="383.575"
            width="1.81614"
            height="1.81614"
            transform="rotate(-85.5031 645.899 383.575)"
            fill="#00F0FF"
          />
          <rect
            x="653.628"
            y="673.816"
            width="4.91407"
            height="4.91407"
            transform="rotate(-85.5031 653.628 673.816)"
            fill="#00F0FF"
          />
          <rect
            x="511.051"
            y="761.173"
            width="4.91407"
            height="4.91407"
            transform="rotate(-85.5031 511.051 761.173)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            x="471.367"
            y="610.177"
            width="3.43444"
            height="3.43443"
            transform="rotate(-85.5031 471.367 610.177)"
            fill="#3DFFFB"
          />
          <rect
            x="874.253"
            y="829.381"
            width="6.3883"
            height="6.38829"
            transform="rotate(-85.5031 874.253 829.381)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            width="6.82082"
            height="6.82082"
            transform="matrix(0.078411 -0.996921 0.996922 0.0784011 1161.79 711.173)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            width="13.7755"
            height="13.7755"
            transform="matrix(0.0784036 -0.996922 0.996921 0.0784085 1218.05 567.86)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            width="6.41004"
            height="6.41004"
            transform="matrix(-0.0784061 0.996922 0.996922 0.0784061 1061.7 369.816)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            width="6.82082"
            height="6.82082"
            transform="matrix(0.078411 -0.996921 0.996922 0.0784011 1222.73 371.441)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            width="6.82082"
            height="6.82082"
            transform="matrix(0.0784011 -0.996922 0.996921 0.078411 1247.09 835.914)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            x="1048.85"
            y="957.376"
            width="6.82083"
            height="6.82083"
            transform="rotate(-85.503 1048.85 957.376)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            width="4.77521"
            height="4.7752"
            transform="matrix(0.078399 -0.996922 0.996921 0.0784131 1083.09 791.083)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            x="1102.71"
            y="850.716"
            width="8.88223"
            height="8.88223"
            transform="rotate(-85.503 1102.71 850.716)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            width="5.8419"
            height="5.8419"
            transform="matrix(-0.958331 -0.28566 0.285693 -0.958321 941.961 566.124)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            width="4.5702"
            height="4.5702"
            transform="matrix(-0.996921 -0.0784134 0.0783987 -0.996922 830.248 488.447)"
            fill="#00D1FF"
          />
          <rect
            width="5.49007"
            height="5.49007"
            transform="matrix(0.958326 0.285676 0.285676 -0.958326 638.328 588.635)"
            fill="#001AFF"
            fill-opacity="0.5"
          />
          <rect
            x="668.581"
            y="454.163"
            width="5.8419"
            height="5.8419"
            transform="rotate(-163.401 668.581 454.163)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            width="5.8419"
            height="5.8419"
            transform="matrix(-0.958331 -0.28566 0.285693 -0.958321 1061.65 517.127)"
            fill="#0066FF"
            fill-opacity="0.5"
          />
          <rect
            x="848.542"
            y="360.986"
            width="4.22361"
            height="4.22361"
            transform="rotate(-175.503 848.542 360.986)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            width="4.08708"
            height="4.08708"
            transform="matrix(-0.958333 -0.285652 0.2857 -0.958319 994.712 646.326)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            x="1048.13"
            y="640.609"
            width="7.60226"
            height="7.60226"
            transform="rotate(-163.401 1048.13 640.609)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            width="3.27281"
            height="3.27281"
            transform="matrix(0.0784165 -0.996921 0.996922 0.0783957 605.519 595.667)"
            fill="#00FFF0"
            fill-opacity="0.6"
          />
          <rect
            x="576.734"
            y="811.524"
            width="3.68718"
            height="3.68718"
            transform="rotate(-85.503 576.734 811.524)"
            fill="#00FFF0"
          />
          <rect
            width="4.07109"
            height="4.07109"
            transform="matrix(-0.0784062 0.996921 0.996922 0.078406 453.212 553.504)"
            fill="#00FFF0"
          />
          <rect
            x="534.627"
            y="495.837"
            width="4.33199"
            height="4.33199"
            transform="rotate(-85.503 534.627 495.837)"
            fill="#00FFF0"
          />
          <rect
            width="4.33199"
            height="4.33199"
            transform="matrix(0.0783984 -0.996922 0.996921 0.0784138 851.481 665.445)"
            fill="#00FFF0"
            fill-opacity="0.5"
          />
          <rect
            x="738.803"
            y="717.218"
            width="2.37476"
            height="2.37476"
            transform="rotate(-85.503 738.803 717.218)"
            fill="#00FFF0"
            fill-opacity="0.5"
          />
          <rect
            x="660.963"
            y="863.698"
            width="4.33199"
            height="4.33199"
            transform="rotate(-120.813 660.963 863.698)"
            fill="#0500FF"
            fill-opacity="0.5"
          />
          <rect
            x="616.641"
            y="764.428"
            width="3.02452"
            height="3.02452"
            transform="rotate(-85.503 616.641 764.428)"
            fill="#00D1FF"
            fill-opacity="0.6"
          />
          <rect
            x="646.334"
            y="788.651"
            width="8.15041"
            height="8.15041"
            transform="rotate(-85.503 646.334 788.651)"
            fill="#6100FF"
            fill-opacity="0.5"
          />
          <g opacity="0.5">
            <rect
              x="442.089"
              y="479.686"
              width="3.27281"
              height="3.27281"
              transform="rotate(-85.5031 442.089 479.686)"
              fill="#00FFF0"
              fill-opacity="0.6"
            />
            <rect
              width="3.68718"
              height="3.68718"
              transform="matrix(0.0784151 -0.996921 0.996922 0.0783971 413.304 695.544)"
              fill="#00FFF0"
            />
            <rect
              width="4.07109"
              height="4.07109"
              transform="matrix(-0.078406 0.996922 0.996921 0.0784062 289.783 437.528)"
              fill="#00FFF0"
            />
            <rect
              width="4.33199"
              height="4.33199"
              transform="matrix(0.0783982 -0.996922 0.996921 0.078414 371.197 379.856)"
              fill="#00FFF0"
            />
            <rect
              x="688.051"
              y="549.465"
              width="4.33199"
              height="4.33199"
              transform="rotate(-85.5031 688.051 549.465)"
              fill="#00FFF0"
              fill-opacity="0.5"
            />
            <rect
              x="575.374"
              y="601.237"
              width="2.37476"
              height="2.37476"
              transform="rotate(-85.5031 575.374 601.237)"
              fill="#00FFF0"
              fill-opacity="0.5"
            />
            <rect
              x="497.534"
              y="747.717"
              width="4.33199"
              height="4.33199"
              transform="rotate(-120.813 497.534 747.717)"
              fill="#0500FF"
              fill-opacity="0.5"
            />
            <rect
              x="453.212"
              y="648.447"
              width="3.02452"
              height="3.02452"
              transform="rotate(-85.5031 453.212 648.447)"
              fill="#00D1FF"
              fill-opacity="0.6"
            />
            <rect
              width="8.15041"
              height="8.15041"
              transform="matrix(0.0784018 -0.996922 0.996921 0.0784103 482.905 672.674)"
              fill="#6100FF"
              fill-opacity="0.5"
            />
          </g>
        </svg> */}
    </>
  )
}

export default Contactimage2
